module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }